import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy } from "lodash";

import { Graph_QL, DynamicDataObk } from "../..";
import { ReportData } from "../../../Definitions";

export type ReportItem = DynamicDataObk<ReportData[]>

const reportDataAdapter = createEntityAdapter({
  selectId: (item: ReportItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<ReportItem, string>, {con, data}: ReportItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "reportId")
    data.forEach((entry) => dataDictionary[entry.reportId!] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      reportDataAdapter.upsertOne(state, newPayload);
    }
  } else { reportDataAdapter.addOne(state, {con, data})}
}

const reportSlice = createSlice({
  name: "reports",
    initialState: reportDataAdapter.getInitialState(),
      reducers: {
        maintained: (state, {payload}:PayloadAction<ReportItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const ReportActions = reportSlice.actions;
export default reportSlice.reducer;